__turbopack_context__.v({
  "closeButton": "mobile-saved-search-sheet-module-scss-module__p09ZzG__closeButton",
  "closeIcon": "mobile-saved-search-sheet-module-scss-module__p09ZzG__closeIcon",
  "title": "mobile-saved-search-sheet-module-scss-module__p09ZzG__title",
});
